import { useQuery } from 'react-query';
import { useTranslation } from 'react-i18next';

import { useApiContext } from 'context/ApiContext';
import { KEYS } from 'helpers/react-query.config';
import { useGlobalContext } from 'context/GlobalContext';

const useGetAllServiceClass = (id?: number) => {
  const { t } = useTranslation('global');
  const { showApiError } = useGlobalContext();
  const { catalog: catalogApi } = useApiContext();

  // GET ALL Service class
  return useQuery(
    [KEYS.catalog.serviceClass.generalSearchInTickets(id)],
    () =>
      catalogApi.serviceClass.generalSearchServiceClass({
        isExport: true,
        enabled: true
      }),
    {
      select: (data) => data?.data?.data?.items,
      onError: (error) =>
        showApiError(
          error,
          t('common.commonMessages.genericRequestError'),
          3000
        ),
      refetchOnWindowFocus: false
    }
  );
};

export default useGetAllServiceClass;
